module.exports = __webpack_public_path__ + "img/thumbnail_BushDog_j_normal.2a7cee38.png";